module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"control_panel":"Control Panel"},"zh-CHS":{"control_panel":"控制面板"}}')
  delete Component.options._Ctor
}
